import axios from 'axios';

export interface CreativePreview {
  dsp_creative_id: string;
  name: string | null;
  preview_url: string | null;
  type: string | null;
  file_url: string | null;
  tag_content: string | null;
  click_url: string | null;
  size: string | null;
}

const PATH = '/reporting-2.0/creative-previews';

/**
 * Artwork for reported creative ids. Ids the API cannot resolve are simply
 * absent from the response rather than returned empty, so the caller shows a
 * placeholder instead of a broken image.
 */
export const fetchCreativePreviews = async (
  dspCreativeIds: string[],
  signal?: AbortSignal,
): Promise<Map<string, CreativePreview>> => {
  if (dspCreativeIds.length === 0) return new Map();
  const response = await axios.post(PATH, { dsp_creative_ids: dspCreativeIds }, { signal });
  const rows = (response.data?.data ?? []) as CreativePreview[];
  return new Map(rows.map(row => [row.dsp_creative_id, row]));
};
